import { ReactNode } from 'react';
import {
  Tooltip as AriaTooltip,
  TooltipProps as AriaTooltipProps,
  TooltipTrigger,
} from 'react-aria-components';

import styles from './Tooltip.module.css';

export interface TooltipProps extends AriaTooltipProps {
  children?: ReactNode;
  /**
    The placement of the element with respect to its anchor element.
  */
  placement?: 'top' | 'bottom' | 'left' | 'right';
  /**
    label for Tooltip component
  */
  label?: string;
  /**
    Whether the tooltip should be disabled, independent from the trigger.
  */
  isDisabled?: boolean;
  /**
    The delay time for the tooltip to show up.
  */
  delay?: number;
  /**
    The delay time for the tooltip to close.
  */
  closeDelay?: number;
  /**
    By default, opens for both focus and hover. Can be made to open only for focus.
  */
  trigger?: 'focus';
  /**
    Controls the visibility of the tooltip
  */
  visible?: boolean;
}

export const Tooltip = ({
  label,
  placement = 'bottom',
  isDisabled = false,
  delay = 0,
  closeDelay,
  children,
  trigger,
  visible,
  ...props
}: TooltipProps) => {
  return (
    <TooltipTrigger
      isDisabled={isDisabled}
      delay={delay}
      closeDelay={closeDelay}
      trigger={trigger}
      isOpen={visible}
    >
      {children}
      <AriaTooltip className={styles.tooltip} placement={placement} {...props}>
        <div data-placement={placement}>{label}</div>
      </AriaTooltip>
    </TooltipTrigger>
  );
};

export default Tooltip;
